import actions from '@/store/modules/poLookup/actions';
import mutations from '@/store/modules/poLookup/mutations';
import PoLookup from '@/store/modules/poLookup/constants';

const state = {
  searchText: '',
  searchStatus: PoLookup.searchStatusEnum.notSearched,
  searchResults: null,
  pageSize: 10,
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
